// eslint-disable-next-line import/prefer-default-export
export const ID = 'COURSE_OUTLINE';
